import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip
} from 'recharts';

interface FeatureImportanceProps {
  data: {
    feature: string;
    importance: number;
  }[];
  width?: number;
  height?: number;
}

/**
 * Bar chart component to display feature importances.
 */
export const FeatureImportance: React.FC<FeatureImportanceProps> = ({
  data,
  width = 400,
  height = 300
}) => {
  if (!data || data.length === 0) {
    return <div className="p-4 text-center text-gray-500">No feature importance data available.</div>;
  }

  return (
    <div style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="feature" tick={{ fontSize: 12 }} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="importance" fill="#3b82f6" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};